import * as types from "./types";

const initialState = {
  list: [],
  meta: {},
  client_report: {},
  report_download: {},
};

const applicantReports = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_APPLICANT_REPORTS_RESPONSE:
      return {
        ...state,
        list: action.payload,
      };
    case types.UPLOAD_APPLICANT_REPORTS_RESPONSE:
      return {
        ...state,
        client_report: action.payload,
      };
    case types.GET_APPLICANT_DOWNLOAD_REPORTS_RESPONSE:
      return {
        ...state,
        report_download: action.payload,
      };
    case types.DELETE_APPLICANT_REPORTS_RESPONSE:
      return {
        ...state,
        client_report: action.payload,
      };
    default:
      return state;
  }
};

export default applicantReports;
